export const iconFontAwesomeArrowsArrowDownUpLock = (
	<i className="fa-solid fa-arrow-down-up-lock"></i>
);
